import { ImmerStateCreator } from './store.types';

type TBookState = {
   state: {
      hasUnlockedChapter2: boolean;
      hasUnlockedChapter3: boolean;
      hasUnlockedChapter4: boolean;
      hasUnlockedChapter5: boolean;
      hasUnlockedChapter6: boolean;
      hasUnlockedChapter7: boolean;
      hasUnlockedChapter8: boolean;
      hasUnlockedChapter9: boolean;
      chaptersUnlocked: number[];
   };
};

type TBookActions = {
   actions: {
      buyNextChapter: () => void;
   };
};

type TBookSlice = TBookState & TBookActions;
export type TNamedBookSlice = { book: TBookSlice };

export const getBookInitialState = (): TBookState['state'] => {
   return {
      hasUnlockedChapter2: false,
      hasUnlockedChapter3: false,
      hasUnlockedChapter4: false,
      hasUnlockedChapter5: false,
      hasUnlockedChapter6: false,
      hasUnlockedChapter7: false,
      hasUnlockedChapter8: false,
      hasUnlockedChapter9: false,
      chaptersUnlocked: [],
   };
};

export const createBookSlice: ImmerStateCreator<TNamedBookSlice, TBookSlice> = (set, get) => ({
   /***************************
    * State
    ***************************/
   state: getBookInitialState(),

   /***************************
    * Actions
    ***************************/
   actions: {
      buyNextChapter: () => {
         const chapters = get().book.state.chaptersUnlocked;
         const maxChapterNumber = 9;

         if (chapters.length < maxChapterNumber) {
            const nextChapterNumber = chapters.length + 2;

            return set((state) => {
               (state.book.state as any)[`hasUnlockedChapter${nextChapterNumber}`] = true;
               state.book.state.chaptersUnlocked = [...chapters, nextChapterNumber];
            });
         }
      },

   },
});
